export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12071.736e74c8.jpg";